export interface MfaStatus {
	confirmed_at: string | null;
	enabled_methods: string[];
	recovery_codes_remaining: number;
	two_factor_enabled: boolean;
	/** Whether the user's company requires all users to enable 2FA. */
	is_2fa_enforced: boolean;
	/** True when enforcement is on and the user has not yet enrolled — forces the setup modal. */
	setup_required: boolean;
}

/** Admin-managed company-wide 2FA policy (Account Settings › Security). */
export interface Company2faSettings {
	is_2fa_enforced: boolean;
	/** Trusted-device window in hours (1–720). Null = 30-day default. */
	device_timeout_hours: number | null;
}

export interface TotpSetupResource {
	otpauth_url: string;
	qr_svg: string;
	secret: string;
}

export interface RecoveryCodesResource {
	recovery_codes: string[];
}

export const MFA_LOW_CODES_THRESHOLD = 3;

/** Maximum configurable trusted-device window — 30 days in hours (matches the API cap). */
export const COMPANY_2FA_MAX_TIMEOUT_HOURS = 720;
